import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=6ffb28b8&scoped=true"
import script from "./CompanyCard.vue?vue&type=script&lang=ts"
export * from "./CompanyCard.vue?vue&type=script&lang=ts"
import style0 from "./CompanyCard.vue?vue&type=style&index=0&id=6ffb28b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffb28b8",
  null
  
)

export default component.exports